import classNames from "classnames";
import React from "react";
import SquaberTooltip from "../../../../common/SquaberTooltip";

export const TOGGLE_SELECT_TYPE = {
  DEFAULT: "DEFAULT",
  SMALL: "SMALL"
};

export const ToggleSelect = ({
  options,
  value,
  onChange,
  disabled,
  tooltip,
  type = TOGGLE_SELECT_TYPE.DEFAULT
}) => {
  const toggle = (
    <div
      className={classNames("toggle-select", {
        "toggle-select_small": type === TOGGLE_SELECT_TYPE.SMALL
      })}
    >
      {options.map(
        ({
          label,
          value: optionValue,
          tooltipTop,
          tooltipBottom,
          tooltipRight
        }) => {
          const isActive = optionValue === value;

          return (
            <div key={optionValue} className={"toggle-select__option"}>
              <button
                type="button"
                className={classNames("toggle-select__button", {
                  "toggle-select__button_small":
                    type === TOGGLE_SELECT_TYPE.SMALL,
                  "toggle-select__button_active": isActive,
                  "toggle-select__button_disabled": disabled
                })}
                disabled={disabled}
                onClick={() => onChange(optionValue)}
              >
                {label}
              </button>
              {tooltipTop ? (
                <span
                  className={
                    "text-xs text-center text-white w-full gap-1 toggle-select__tooltip toggle-select__tooltip_top font-medium opacity-90"
                  }
                  dangerouslySetInnerHTML={{ __html: tooltipTop }}
                />
              ) : null}
              {tooltipBottom ? (
                <span
                  className={
                    "text-xs text-center text-white w-full gap-1 toggle-select__tooltip toggle-select__tooltip_bottom font-medium opacity-90"
                  }
                  dangerouslySetInnerHTML={{ __html: tooltipBottom }}
                />
              ) : null}
              {tooltipRight ? (
                <span
                  className={
                    "text-xs text-center text-white w-full gap-1 toggle-select__tooltip toggle-select__tooltip_right font-medium opacity-90"
                  }
                  dangerouslySetInnerHTML={{ __html: tooltipRight }}
                />
              ) : null}
            </div>
          );
        }
      )}
    </div>
  );

  return tooltip ? (
    <SquaberTooltip title={tooltip}>{toggle}</SquaberTooltip>
  ) : (
    toggle
  );
};
